<template>
  <ul class="navContent">
    <!-- 遍历 router 菜单数据 -->
    <lfmenuitem :key="index" v-for="(item, index) in items">
      <!-- 对于没有 children 子菜单的 item -->
      <li
        class="sliderTag"
        :class="item.isCurr ? 'curr' : ''"
        v-if="!item.children"
      >
        <a
          @click="handleTarget(item,this)"
          class="hvr-shutter-out-horizontal link-substance solution"
          :data-id="item.id"
          >{{ $Lang.L({cn:item.displayNameCN,en:item.displayNameEN,hk:''}) }}</a
        >
      </li>

      <!-- 对于有 children 子菜单的 item -->
      <template v-else>
        <div
          class="subNav"
          :style="{ 'padding-left': level + 'px' }"
          @click="handleToggleShow($event)"
        >
          {{ $Lang.L({cn:item.displayNameCN,en:item.displayNameEN,hk:''})}} 
          <!-- {{item.displayNameCN}} -->
          <!-- {{ JSON.stringify(item) }} -->
        </div>
        <!-- 递归操作 -->
        <lfmenu
          :items="item.children"
          :level="level + 10"
          class="ishide"
        ></lfmenu>
        <!-- class="ishide"  -->
      </template>
    </lfmenuitem>
  </ul>
</template>
<script>
import lfmenuitem from "./lfmenuitem.vue";
export default {
  name: "lfmenu",
  props: ["items", "level", "target"], // Menu 组件接受一个 router 作为菜单数据
  components: { lfmenuitem },
  data() {
    return {
      curr: 0,
    };
  },
  mounted() {
    // debugger;
    // this.target ? (this.$data.curr = this.target) : "";
  },
  methods: {
    
    handleToggleShow(e) {
      //  debugger;
      e.currentTarget.classList.contains("currentDt")
        ? e.currentTarget.classList.remove("currentDt")
        : e.currentTarget.classList.add("currentDt");
      // e.currentTarget.nextSibling.hidden=!e.currentTarget.nextSibling.hidden;
      e.currentTarget.nextSibling.classList.contains("ishide")
        ? e.currentTarget.nextSibling.classList.remove("ishide")
        : e.currentTarget.nextSibling.classList.add("ishide");
    },
    handleTarget(item,el) {
      var topParent=this.findParentComponent()

        topParent.$children.forEach((compotnent) => {
          compotnent.$el.firstElementChild.classList.remove('currentDt')
          compotnent.$el.lastElementChild.classList.add('ishide')
        })
        topParent.items.forEach((element) => {
          topParent.resetChild(element, 0, item.id);
        })

       item.isCurr = true;
       this.climbUpComponent()
    },
    resetChild(item,count,tag) {
      if(item.children){
        if (item.children.length>0) {
            item.children.forEach((ele) => {
              this.resetChild(ele, count++,tag);
            });
        } else {
          item.isCurr = false;
        }
      }else{ 
        item.isCurr=false;
      }
    },
    climbUpComponent()
    {
      let currentInstance = this;
      while(currentInstance)
      {
        if(currentInstance.$el.previousElementSibling&&currentInstance.$el.previousElementSibling.classList.contains('subNav'))
        {
          currentInstance.$el.previousElementSibling.classList.add('currentDt')
        }
        if(currentInstance.$el&&currentInstance.$el.classList.contains('ishide'))
        {
          currentInstance.$el.previousElementSibling.classList.remove('ishide')
        }
        if(currentInstance.$el&&currentInstance.$el.classList.contains('navContent'))
        {
          currentInstance.$el.classList.remove('ishide')
        }
        if (currentInstance.$el.classList.contains('leftNavMenu')) {
          return;
        }
        currentInstance = currentInstance.$parent;
      }
    },
    findParentComponent() {
      let currentInstance = this.$parent;
      while (currentInstance) {
        if (currentInstance.$el.className=='navContent leftNavMenu') {
          return currentInstance;
        }
        currentInstance = currentInstance.$parent;
      }
      return null;
    }
  },
  computed: {},
};
</script>
<style scoped>
</style>


